import { memo } from 'react';
import { Card, Grid } from '@mui/material';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

const Header = memo(function HeaderPre({ selectedLabel = 'INBOX' }) {
    const getLabelTitle = (labelName) => {
        switch (labelName) {
            case 'SENT':
                return 'Gönderilen Postalar';
            case 'INBOX':
            default:
                return 'Gelen Kutusu';
        }
    };

    return (
        <MDBox position="relative" mb={0}>
            <Card
                sx={{
                    py: 1,
                    px: 2,
                    boxShadow: 'none',
                    backgroundColor: 'transparent',
                    borderBottom: '1px solid',
                    borderColor: 'grey.200',
                    borderRadius: 0,
                }}
            >
                <Grid container sx={{
                    alignItems: "center"
                }}>
                    <Grid>
                        <MDTypography variant="h6" fontWeight="medium" color="dark">
                            {getLabelTitle(selectedLabel)}
                        </MDTypography>
                    </Grid>
                </Grid>
            </Card>
        </MDBox>
    );
});

export default Header;
